import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/app/config/environments/environment";
import { ActivesoftIntegration } from "../models/interfaces/activesoft-integration.interface";

@Injectable()
export class ActivesoftIntegrationService {
  constructor(private http: HttpClient) {}

  EDIT_PATH = 'activesoft'
  QUERY_PATH = 'activesoft/q/integration'

  public createOrUpdate(activesoftIntegration: ActivesoftIntegration): Observable<ActivesoftIntegration> {
    return this.http.put<ActivesoftIntegration>(`${environment.api.baseUrl}/${this.EDIT_PATH}`, activesoftIntegration)
  }

  getByIdUser(idUser: string): Observable<ActivesoftIntegration> {
    return this.http.get<ActivesoftIntegration>(`${environment.api.baseUrl}/${this.QUERY_PATH}`,
      {
        params: { idUser: `${idUser}` },
      }
    )
  }
}
